module.exports = __webpack_public_path__ + "static/step-2-2b-cron-manual-d2c10a42919aa3731027dd7356ef19b5.png";